<div>
  <div class="date-group" *ngFor="let dateChunk of dateChunks">

    <!-- date divider -->
    <div class="my-3 position-relative">
      <hr class="w-100 position-absolute h-50 m-0" style="z-index: -1; bottom: 0; border-color: #ABB7C7;" />
      <div class="text-center">
        <div class="bg-white px-4 d-inline-block text-uppercase text-muted">{{ dateChunk.date | date:'MMM d, yyyy' }}</div>
      </div>
    </div>

    <!-- user group -->
    <div class="user-group m-auto d-flex flex-column" [ngClass]="{'user-group--right align-items-end': !senderChunk.sender.client}" *ngFor="let senderChunk of dateChunk.senderChunks">
      <div class="time-group" [ngClass]="{'mt-4 right-group': !firstTimeGroup}" *ngFor="let timeChunk of senderChunk.timeChunks; first as firstTimeGroup; last as lastTimeGroup">
        <div class="w-60 transcript-message" [ngClass]="setMessageConditionalStyles(message, lastMessage, lastTimeGroup)" *ngFor="let message of timeChunk.messages; last as lastMessage">
          <div class="px-3 pb-2 pt-3"*ngIf="message.attachments && message.attachments.length">
            <button id="new-attachment" mat-button [matMenuTriggerFor]="documentHandler" style="padding: 0; margin-bottom: 10px; outline: none; height: 29px;">
              <i class="icon-20-document" style="transform: translate(0px, -2px);"></i> New Attachment
            </button>
            <mat-menu #documentHandler="matMenu">
              <button id="view-attachment" mat-menu-item *ngFor="let attachment of message.attachments">
                <a href="{{ attachment.url }}" target="_blank">View</a>
              </button>
            </mat-menu>
          </div>
          <div *ngIf="message.templateId && message.isAutomated" [ngClass]="{'bg-primary pb-2 px-3 pt-2 automated-transcript font-weight-bold': 'message.templateId'}"><span>Automated SMS - Attempt</span>
            <span class="ml-1 font-weight-bold" *ngIf="message.automatedAttemptNumber">{{ message.automatedAttemptNumber }}</span>
          </div>
          <div class="transcript-message-content px-3 pt-3 pb-2" [innerHtml]="message.content" data-cy="sms-message-content"></div>
          <!-- Message error block -->
          <ng-container *ngIf="message.errorMessage">
            <hr class="bg-white mx-3 mb-1 mt-2" />
            <div class="px-3 pt-1 pb-2 transcript-error-alert-message">
              <span class="transcript-error-alert-header">MESSAGE NOT DELIVERED: </span>
              <span class="transcript-error-alert-content">{{ message.errorMessage }}</span></div>
          </ng-container>
          <!-- End of message error block -->
          <div class="transcript-message-time text-right mt-2 my-2 px-3 pb-2" *ngIf="lastMessage">
            {{ setTimestampText(message) }} {{
              ((now$ | async) - (message.modifiedTimestamp * 1000) < 60*60*1000) ?
              (message.modifiedTimestamp * 1000 | timeago | lowercase) :
              (message.modifiedTimestamp * 1000 | date: 'h:mm a')
            }}
          </div>
        </div>
      </div>

      <div *ngIf="senderChunk && senderChunk.sender && senderChunk.sender.fullName" class="user-avatar d-flex align-items-center w-60" [ngClass]="{'flex-row-reverse ': !senderChunk.sender.client}">
        <user-avatar-component [user]="{id: senderChunk.sender.id, fullName: senderChunk.sender.fullName}"></user-avatar-component>
        <span class="user-name mx-2">{{ senderChunk.sender.fullName }}</span>
        <!-- <span *ngIf="!!senderChunk.templateId" class="mr-auto user-name">Automated</span> -->
      </div>
    </div>

  </div>

